import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        bgcolor: "#f9fafb",
        px: 2,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: "6rem", md: "10rem" },
          fontWeight: "bold",
          color: "primary.main",
          lineHeight: 1,
        }}
      >
        404
      </Typography>

      <Typography variant="h4" sx={{ fontWeight: 600, color: "text.primary", mb: 1 }}>
        Oops! Page not found
      </Typography>

      <Typography variant="body1" sx={{ color: "text.secondary", maxWidth: 420, mb: 4 }}>
        The page you’re looking for doesn’t exist, was removed, or the link you followed is broken.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={() => {
            window.open(process.env.REACT_APP_REDIRECT_PATH);
        }}
        sx={{
          borderRadius: "8px",
          px: 4,
          py: 1.5,
          textTransform: "none",
          fontWeight: 600,
          boxShadow: 3,
          "&:hover": { boxShadow: 6 },
        }}
      >
        Go Back Home
      </Button>
    </Box>
  );
};

export default NotFoundPage;
